import { UploadItem } from '@Types';

export enum OrganizationDocumentTypesEnum {
  'ANNUAL_ACCOUNTS' = 'ANNUAL_ACCOUNTS',
  'GOVERNING_DOCUMENT' = 'GOVERNING_DOCUMENT',
}

export interface KeyDocument extends UploadItem {
  document_type: OrganizationDocumentTypesEnum;
}

export interface KeyPerson {
  id?: number;
  first_name: string;
  last_name: string;
  email: string;
  date_of_birth: string;
  is_representative: boolean;
  is_owner: boolean;
  is_director: boolean;
  is_executive: boolean;
  address1: string;
  address2?: string;
  address3?: string;
  city: string;
  county: string;
  postcode: string;
}

export interface RegisteredDetails {
  legal_name?: string;
  type_of_organization?: string;
  legal_structure?: string;
  phone_number?: string;
  address1?: string;
  address2?: string;
  address3?: string;
  city?: string;
  county?: string;
  postcode?: string;
  set_up_year?: string;
  company_number?: string;
  charity_number?: string;
  other_registration_number?: string;
}

export interface OrganizationFormType extends RegisteredDetails {
  representative?: string;
  key_people?: string;
  all_people_submitted?: boolean;
}

export interface DueDiligenceData {
  key_documents: KeyDocument[];
  annual_accounts: { income: string };
  bank_details: { account_number: string; sort_code: string; account_name: string };
  registered_details: RegisteredDetails;
  key_people: {
    all_people_submitted: boolean;
    people: KeyPerson[];
  };
}
